import * as _ from 'lodash'; const { uniq } = _.uniq ? _ : _.default
const MAX_QUEUE_SIZE = 200
const MAX_CONCURRENCY = 2
const DEFAULT_WAIT = 100

export interface BatchedOpts {
	wait?: number
	maxQueueSize?: number
	maxConcurrency?: number
	log_unhandled?: boolean
	trace?: string
}

export type Id = string | number
export type Executor<I, R> = (items: I[]) => Promise<R>
export type ExtractResponse<I,R,T> = (item: I | I[], result: R, queued: I[]) => T

export function batched<T=any,R=any,I = Id>(execute: Executor<I, R>, get: ExtractResponse<I,R,T>, { wait = DEFAULT_WAIT, maxQueueSize = MAX_QUEUE_SIZE, maxConcurrency = MAX_CONCURRENCY, trace, log_unhandled = true }: BatchedOpts = {}) {
	let queued: I[], queuedRequest: Promise<R>, executeQueued, queuedTimeout
	let samples = 0
	let avgBatchSize = 0
	let outstanding = new Set<Promise<void>>()
	return (item: I | I[]) => {
		// get names using queued/batched requests
		if (!queued) {
			queued = []
			queuedRequest = new Promise((resolve, reject) => {
				let hasRun
				executeQueued = (mustRun) => {
					if (hasRun)
						return
					clearTimeout(queuedTimeout)
					if (outstanding.size >= maxConcurrency && mustRun !== true) {
						for (let promise of outstanding) {
							return promise.then(executeQueued)
						}
					}
					if (trace) {
						avgBatchSize = ((samples * avgBatchSize) + queued.length) / ++samples
						const unique = uniq(queued)
						let uniqTxt = unique.length < queued.length ? ` (${unique} unique)` : ''
						console.log(`[Batched ${trace}] Fetch #${samples} Queue: ${queued.length}${uniqTxt}, Average: ${avgBatchSize.toFixed(2)}`)
					}
					let promise = execute(queued).then((result) => {
						outstanding.delete(promise)
						resolve(result)
					}, function(error) {
						outstanding.delete(promise)
						reject(error)
						if (log_unhandled) {
							// hopefully this can be removed
							setTimeout(() => {
								if (!error.isHandled) {
									error.isHandled = true
									console.error('Unhandled error in batched response', error.toString())
								}
							}, 100)
						}
					})
					outstanding.add(promise)
//					allQueued.delete(queued.id)
					queued = null
					queuedRequest = null
					hasRun = true
				}
				queuedTimeout = setTimeout(executeQueued, wait)
			})
		}
		if (Array.isArray(item)) {
			queued.push(...item)
		} else {
			queued.push(item)
		}
		let queuedForRequest = queued
		let result = queuedRequest.then(result => get(item, result, queuedForRequest))
		if (queued.length >= maxQueueSize) {
			executeQueued(true)
		}
		return result
	}
}
export default batched
